import { Injectable } from '@angular/core';
import { ModalMensajeUsuarioComponent } from '../modal/modal-mensaje-usuario/modal-mensaje-usuario.component';
import { NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class MessageService {
  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    //private toastr: ToastrService
  ) { }
  shortError(message: string): void{
    console.log('short -->',message)
    //this.toastr.success(message);
  }
  shortSucces(message: string,tipo: string): void{

  }

  largeError(message: string, icono = "icofont icofont-ui-close"):void{
    const modalMensaje = this.modalService.open(ModalMensajeUsuarioComponent,{})
    modalMensaje.componentInstance.mensaje = message
    modalMensaje.componentInstance.tipo = "error"
    modalMensaje.componentInstance.icono = icono
    /*modalMensaje.result.then((result)=>{
      console.log("1",result)
    },(reason) =>{
      this.formUsuario.imagen = reason
    });*/
  }

  largeSucces(message: string, icono = "icofont icofont-ui-close"):void{
    const modalMensaje = this.modalService.open(ModalMensajeUsuarioComponent,{size:'sm'})
    modalMensaje.componentInstance.mensaje = message
    modalMensaje.componentInstance.tipo = "error"
    modalMensaje.componentInstance.icono = icono
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/message.service.ts